import projectOne from "../assets/resturent.png";
import projectTwo from "../assets/coffee.png";
import projectThree from "../assets/crypto.png";

const projects = {
  1: {
    title: "Resturent Order Management",
    image: projectOne,
    description: (
      <>
        <p>
        Resturent managment is Full stack Project. Admin Authintication.User Authintication User can easily booking her food by categogies.User Also can Online Payment.
        </p>
      </>
    ),
    githubclint: "https://github.com/AmhjadKhan/resturent_clint",
    githubserver: "https://github.com/AmhjadKhan/Resturent_server",
    demo: "https://resturentorders.netlify.app/",
  },
  2: {
    title: "Coffee Crud App",
    image: projectTwo,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    githubclint: "https://github.com/AmhjadKhan/resturent_clint",
    githubserver: "https://github.com/AmhjadKhan/Resturent_server",
    demo: "https://resturentorders.netlify.app/",
  },
  3: {
    title: "Crypto Project",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    githubclint: "https://github.com/AmhjadKhan/resturent_clint",
    githubserver: "https://github.com/AmhjadKhan/Resturent_server",
    demo: "https://resturentorders.netlify.app/",
  },
  4: {
    title: "my apps",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  
};

export default projects;
